// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1CJvE","col":"styles_col__3Eo-d","actions":"styles_actions__2Gtzj","conflict":"styles_conflict__1pF6c"};